export const initialStatefields = [
  {
      package_account_type: "4",
      package: "1",
      dynamic:true,
      form: [
        {
          id: "package_name",
          displayLabel:"Package name",
          type: "input",
          placeholder: "Enter Package Name",
          config: {
            dataType: "text",
          },
          value: "",
          validation: {
            required: true,
          },
          valid: false,
        },
        {
          id: "package_price",
          displayLabel:"Package price",
          type: "input",
          placeholder: "Enter Price",
          config: {
            dataType: "text",
          },
          value: "",
          validation: {
            required: true,
          },
          valid: false,
        },
        {
          id: "package_duration",
          object_key:"pack_duration",
          displayLabel:"Package duration",
          type: "select",
          placeholder: "select Package Duration",
          config: {
            dataType: "text",
          },
          options: [
            {
              id: 1,
              value: "1m",
              displayValue: "1 Months",
            },
            {
              id: 2,
              value: "6m",
              displayValue: "6 Months",
            },
            {
              id: 3,
              value: "12m",
              displayValue: "12 Months",
            },
          ],
          value: "",
          validation: {
            required: true,
          },
          valid: false,
        },
        {
          id: "chargerate",
          object_key:"charge_rate",
          displayLabel:"Charge Rate",
          type: "radio",
          placeholder: "Select Charge Rate",
          config: {
            dataType: "radio",
          },
          options: [
            {
              id: 1,
              value: ".58",
              displayValue: "$0.58",
            },
            {
              id: 2,
              value: "unlimited",
              displayValue: "Unlimited",
            },
          ],
          value: "",
          validation: {
            required: true,
          },
          valid: false,
        },
        {
          id: "batterytype",
          object_key:"battery_type",
          displayLabel:"Battery Type",
          type: "radio",
          placeholder: "Select battery type",
          config: {
            dataType: "radio",
          },
          options: [
            {
              id: 1,
              value: ".58",
              displayValue: "$0.58",
            },
            {
              id: 2,
              value: "unlimited",
              displayValue: "Unlimited",
            },
          ],
          value: "",
          validation: {
            required: true,
          },
          valid: false,
        },
        // {
        //   id: "parkingfee",
        //   object_key:"parking_charge",
        //   displayLabel:"Parking",
        //   type: "input",
        //   options:[],
        //   config: {
        //     dataType: "text",
        //   },
        //   validation: {
        //     required: false,
        //   },
        //   valid: true,
        // },
      ],
    },
   
  {package_account_type: '1', package: '16' , dynamic:true,form: [
    {
      id: "package_name",
      displayLabel:"Package name",
      type: "input",
      placeholder: "Enter Package Name",
      config: {
        dataType: "text",
      },
      value: "",
      validation: {
        required: true,
      },
      valid: false,
    },
    {
      id: "package_price",
      displayLabel:"Package price",
      type: "input",
      placeholder: "Enter Price",
      config: {
        dataType: "text",
      },
      value: "",
      validation: {
        required: true,
      },
      valid: false,
    },
    {
      id: "package_duration",
      object_key:"pack_duration",
      displayLabel:"Package duration",
      type: "select",
      placeholder: "select Package Duration",
      config: {
        dataType: "text",
      },
      options: [
        {
          id: 1,
          value: "1m",
          displayValue: "1 Months",
        },
        {
          id: 2,
          value: "6m",
          displayValue: "6 Months",
        },
        {
          id: 3,
          value: "12m",
          displayValue: "12 Months",
        },
      ],
      value: "",
      validation: {
        required: true,
      },
      valid: false,
    },
    {
      id: "chargerate",
      object_key:"charge_rate",
      displayLabel:"Charge Rate",
      type: "radio",
      placeholder: "Select Charge Rate",
      config: {
        dataType: "radio",
      },
      options: [
        {
          id: 1,
          value: ".58",
          displayValue: "$0.58",
        },
        {
          id: 2,
          value: "unlimited",
          displayValue: "Unlimited",
        },
      ],
      value: "",
      validation: {
        required: true,
      },
      valid: false,
    },
    {
      id: "batterytype",
      object_key:"battery_type",
      displayLabel:"Battery Type",
      type: "radio",
      placeholder: "Select battery type",
      config: {
        dataType: "radio",
      },
      options: [
        {
          id: 1,
          value: ".58",
          displayValue: "$0.58",
        },
        {
          id: 2,
          value: "unlimited",
          displayValue: "Unlimited",
        },
      ],
      value: "",
      validation: {
        required: true,
      },
      valid: false,
    },
    // {
    //   id: "parkingfee",
    //   object_key:"parking_charge",
    //   displayLabel:"Parking",
    //   type: "input",
    //   options:[],
    //   config: {
    //     dataType: "text",
    //   },
    //   validation: {
    //     required: false,
    //   },
    //   valid: true,
    // },
  ],},
  {package_account_type: '1', package: '14' ,  dynamic:true,form: [
    {
      id: "package_name",
      displayLabel:"Package name",
      type: "input",
      placeholder: "Enter Package Name",
      config: {
        dataType: "text",
      },
      value: "",
      validation: {
        required: true,
      },
      valid: false,
    },
    {
      id: "package_price",
      displayLabel:"Package price",
      type: "input",
      placeholder: "Enter Price",
      config: {
        dataType: "text",
      },
      value: "",
      validation: {
        required: true,
      },
      valid: false,
    },
    {
      id: "package_duration",
      object_key:"pack_duration",
      displayLabel:"Package duration",
      type: "select",
      placeholder: "select Package Duration",
      config: {
        dataType: "text",
      },
      options: [
        {
          id: 1,
          value: "1m",
          displayValue: "1 Months",
        },
        {
          id: 2,
          value: "6m",
          displayValue: "6 Months",
        },
        {
          id: 3,
          value: "12m",
          displayValue: "12 Months",
        },
      ],
      value: "",
      validation: {
        required: true,
      },
      valid: false,
    },
    
    {
      id: "batterytype",
      object_key:"battery_type",
      displayLabel:"Battery Type",
      type: "radio",
      placeholder: "Select battery type",
      config: {
        dataType: "radio",
      },
      options: [
        {
          id: 1,
          value: ".58",
          displayValue: "$0.58",
        },
        {
          id: 2,
          value: "unlimited",
          displayValue: "Unlimited",
        },
      ],
      value: "",
      validation: {
        required: true,
      },
      valid: false,
    },
    // {
    //   id: "parkingfee",
    //   object_key:"parking_charge",
    //   displayLabel:"Parking",
    //   type: "input",
    //   options:[],
    //   config: {
    //     dataType: "text",
    //   },
    //   validation: {
    //     required: false,
    //   },
    //   valid: true,
    // },
  ],},
  {
    package_account_type: '3', package: '4' , dynamic:true,form: [
      {
        id: "package_name",
        displayLabel:"Package name",
        type: "input",
        placeholder: "Enter Package Name",
        config: {
          dataType: "text",
        },
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "package_price",
        displayLabel:"Package price",
        type: "input",
        placeholder: "Enter Price",
        config: {
          dataType: "text",
        },
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "package_duration",
        object_key:"pack_duration",
        displayLabel:"Package duration",
        type: "select",
        placeholder: "select Package Duration",
        config: {
          dataType: "text",
        },
        options: [
          {
            id: 1,
            value: "1m",
            displayValue: "1 Months",
          },
          {
            id: 2,
            value: "6m",
            displayValue: "6 Months",
          },
          {
            id: 3,
            value: "12m",
            displayValue: "12 Months",
          },
        ],
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "chargerate",
        object_key:"charge_rate",
        displayLabel:"Charge Rate",
        type: "radio",
        placeholder: "Select Charge Rate",
        config: {
          dataType: "radio",
        },
        options: [
          {
            id: 1,
            value: ".58",
            displayValue: "$0.58",
          },
          {
            id: 2,
            value: "unlimited",
            displayValue: "Unlimited",
          },
        ],
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "batterytype",
        object_key:"battery_type",
        displayLabel:"Battery Type",
        type: "radio",
        placeholder: "Select battery type",
        config: {
          dataType: "radio",
        },
        options: [
          {
            id: 1,
            value: ".58",
            displayValue: "$0.58",
          },
          {
            id: 2,
            value: "unlimited",
            displayValue: "Unlimited",
          },
        ],
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      // {
      //   id: "parkingfee",
      //   object_key:"parking_charge",
      //   displayLabel:"Parking",
      //   type: "input",
      //   options:[],
      //   config: {
      //     dataType: "text",
      //   },
      //   validation: {
      //     required: false,
      //   },
      //   valid: true,
      // },
    ],

  },
  {
    package_account_type: '3', package: '5' , dynamic:true,form: [
      {
        id: "package_name",
        displayLabel:"Package name",
        type: "input",
        placeholder: "Enter Package Name",
        config: {
          dataType: "text",
        },
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "package_price",
        displayLabel:"Package price",
        type: "input",
        placeholder: "Enter Price",
        config: {
          dataType: "text",
        },
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "package_duration",
        object_key:"pack_duration",
        displayLabel:"Package duration",
        type: "select",
        placeholder: "select Package Duration",
        config: {
          dataType: "text",
        },
        options: [
          {
            id: 1,
            value: "1m",
            displayValue: "1 Months",
          },
          {
            id: 2,
            value: "6m",
            displayValue: "6 Months",
          },
          {
            id: 3,
            value: "12m",
            displayValue: "12 Months",
          },
        ],
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "chargerate",
        object_key:"charge_rate",
        displayLabel:"Charge Rate",
        type: "radio",
        placeholder: "Select Charge Rate",
        config: {
          dataType: "radio",
        },
        options: [
          {
            id: 1,
            value: ".58",
            displayValue: "$0.58",
          },
          {
            id: 2,
            value: "unlimited",
            displayValue: "Unlimited",
          },
        ],
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "batterytype",
        object_key:"battery_type",
        displayLabel:"Battery Type",
        type: "radio",
        placeholder: "Select battery type",
        config: {
          dataType: "radio",
        },
        options: [
          {
            id: 1,
            value: ".58",
            displayValue: "$0.58",
          },
          {
            id: 2,
            value: "unlimited",
            displayValue: "Unlimited",
          },
        ],
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      // {
      //   id: "parkingfee",
      //   object_key:"parking_charge",
      //   displayLabel:"Parking",
      //   type: "input",
      //   options:[],
      //   config: {
      //     dataType: "text",
      //   },
      //   validation: {
      //     required: false,
      //   },
      //   valid: true,
      // },
    ],

  },
  {
    package_account_type: '5', package: '3' , dynamic:true,form: [
      {
        id: "package_name",
        displayLabel:"Package name",
        type: "input",
        placeholder: "Enter Package Name",
        config: {
          dataType: "text",
        },
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "package_price",
        displayLabel:"Package price",
        type: "input",
        placeholder: "Enter Price",
        config: {
          dataType: "text",
        },
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "package_duration",
        object_key:"pack_duration",
        displayLabel:"Package duration",
        type: "select",
        placeholder: "select Package Duration",
        config: {
          dataType: "text",
        },
        options: [
          {
            id: 1,
            value: "1m",
            displayValue: "1 Months",
          },
          {
            id: 2,
            value: "6m",
            displayValue: "6 Months",
          },
          {
            id: 3,
            value: "12m",
            displayValue: "12 Months",
          },
        ],
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "chargerate",
        object_key:"charge_rate",
        displayLabel:"Charge Rate",
        type: "radio",
        placeholder: "Select Charge Rate",
        config: {
          dataType: "radio",
        },
        options: [
          {
            id: 1,
            value: ".58",
            displayValue: "$0.58",
          },
          {
            id: 2,
            value: "unlimited",
            displayValue: "Unlimited",
          },
        ],
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "batterytype",
        object_key:"battery_type",
        displayLabel:"Battery Type",
        type: "radio",
        placeholder: "Select battery type",
        config: {
          dataType: "radio",
        },
        options: [
          {
            id: 1,
            value: ".58",
            displayValue: "$0.58",
          },
          {
            id: 2,
            value: "unlimited",
            displayValue: "Unlimited",
          },
        ],
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      // {
      //   id: "parkingfee",
      //   object_key:"parking_charge",
      //   displayLabel:"Parking",
      //   type: "input",
      //   options:[],
      //   config: {
      //     dataType: "text",
      //   },
      //   validation: {
      //     required: false,
      //   },
      //   valid: true,
      // },
    ],

  },
  {
    package_account_type: '5', package: '6' , dynamic:true,form: [
      {
        id: "package_name",
        displayLabel:"Package name",
        type: "input",
        placeholder: "Enter Package Name",
        config: {
          dataType: "text",
        },
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "package_price",
        displayLabel:"Package price",
        type: "input",
        placeholder: "Enter Price",
        config: {
          dataType: "text",
        },
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "package_duration",
        object_key:"pack_duration",
        displayLabel:"Package duration",
        type: "select",
        placeholder: "select Package Duration",
        config: {
          dataType: "text",
        },
        options: [
          {
            id: 1,
            value: "1m",
            displayValue: "1 Months",
          },
          {
            id: 2,
            value: "6m",
            displayValue: "6 Months",
          },
          {
            id: 3,
            value: "12m",
            displayValue: "12 Months",
          },
        ],
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "chargerate",
        object_key:"charge_rate",
        displayLabel:"Charge Rate",
        type: "radio",
        placeholder: "Select Charge Rate",
        config: {
          dataType: "radio",
        },
        options: [
          {
            id: 1,
            value: ".58",
            displayValue: "$0.58",
          },
          {
            id: 2,
            value: "unlimited",
            displayValue: "Unlimited",
          },
        ],
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      {
        id: "batterytype",
        object_key:"battery_type",
        displayLabel:"Battery Type",
        type: "radio",
        placeholder: "Select battery type",
        config: {
          dataType: "radio",
        },
        options: [
          {
            id: 1,
            value: ".58",
            displayValue: "$0.58",
          },
          {
            id: 2,
            value: "unlimited",
            displayValue: "Unlimited",
          },
        ],
        value: "",
        validation: {
          required: true,
        },
        valid: false,
      },
      // {
      //   id: "parkingfee",
      //   object_key:"parking_charge",
      //   displayLabel:"Parking",
      //   type: "input",
      //   options:[],
      //   config: {
      //     dataType: "text",
      //   },
      //   validation: {
      //     required: false,
      //   },
      //   valid: true,
      // },
    ],

  },



];

export const HourMapping = {
  "D":" day",
  "W":" week",
  "H":" hrs",
  "M":" month",
  "Y":" year"
};

  //   export const AddOnsIcon = {
  //     "car wash":""
  //     ""
  //   }